import React, { useState } from "react";
import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import { FaEdit } from "react-icons/fa";
import RouteModal from "../../Component/BasicComponents/Modal/RouteModal";
import PlaylistTypeModalContent from "./ModalContent/PlaylistTypeModalContent";
import {
  useAddPlayListType,
  usePlaylistTypeData,
  useUpdatePlayListType,
} from "./hooks/useEdetailing";
import { showToast } from "../../utils/toastUtils";

const playlisttypeDataColumns = (
  handleUpdate: (row: any, Status: string) => void
) => [
  {
    name: "Playlist Types",
    selector: (row: { playlisttype: number | string }) => row.playlisttype,
    sortable: true,
  },
  {
    name: "Created At",
    selector: (row: { created: string }) => row.created,
    sortable: true,
  },
  {
    name: "Action",
    width: "200px",
    cell: (row: any) => (
      <button
        onClick={() => handleUpdate(row, "Update")}
        className="btn btn-primary d-flex align-items-center justify-content-center gap-1"
        style={{ borderRadius: "20px", padding: "3px", width: "70px" }}
      >
        <FaEdit size={14} style={{ fill: "#fff" }} /> Edit
      </button>
    ),
  },
];

const PlaylistType = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editType, setEditType] = useState<number | null>(null);
  const [type, setType] = useState("");

  const [chechStatusSubmitAndUpdate, setchechStatusSubmitAndUpdate] =
    useState<string>("");
  const [filtersState, setFiltersState] = useState<any>({
    limit: 10,
    page: 1,
    search: null,
  });
  const toggleModal = (status: string) => {
    setchechStatusSubmitAndUpdate(status);
    setIsModalOpen(!isModalOpen);
    setType("");
  };
  const { mutate: addPlaylist } = useAddPlayListType();
  const { mutate: updatePlaylistType } = useUpdatePlayListType();
  const { data, isLoading } = usePlaylistTypeData({
    enable: true,
    params: { search: filtersState.search },
  });

  const handleClose = () => {
    setIsModalOpen(false);
    setchechStatusSubmitAndUpdate("");
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!type || type.trim() === "") {
      showToast.warning("Please enter a Playlist Type.");
      return;
    }

    const body = {
      PlaylistTypeName: type,
    };

    if (chechStatusSubmitAndUpdate === "Submit") {
      addPlaylist(body, {
        onSuccess: () => {
          handleClose();
        },
        onError: () => {
          setchechStatusSubmitAndUpdate("");
        },
      });
    } else {
      updatePlaylistType(
        { id: Number(editType), body },
        {
          onSuccess: () => {
            handleClose();
          },
          onError: () => {
            setchechStatusSubmitAndUpdate("");
          },
        }
      );
    }
  };

  const playlisttypeData =
    data?.map((item: any, index: number) => ({
      id: item.EdPlaylistTypeId,
      playlisttype: item?.PlaylistTypeName,
      created: item?.CreatedAt?.split(" ")[0] || "Invalid Date",
    })) || [];

  console.log("playlisttypeDataaaa", playlisttypeData);

  const handleUpdate = (row: any, status: string) => {
    setchechStatusSubmitAndUpdate(status);
    console.log("row", row);
    setType(row.playlisttype);
    setEditType(row.id);
    setIsModalOpen(true);
  };
  const handleSearch = (searchValue: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        search: searchValue,
      };
    });
  };

  return (
    <div className="p-2">
      <PageHeader
        title="Playlist Name"
        buttons={[
          {
            label: "+ Add Playlist Name",
            onClick: () => toggleModal("Submit"),
            color: "#2e8dd3",
          },
          // {
          //   label: "Excel",
          //   onClick: () => alert("Action 2 clicked"),
          //   color: "#43B9B2",
          // },
          // {
          //   label: "CSV",
          //   onClick: () => alert("Action 3 clicked"),
          //   color: "#43B9B2",
          // },
        ]}
      />

      <BasicDataTable
        Title="Playlist Name"
        data={playlisttypeData}
        dynamicHeightOnRowsPerPage={true}
        showSpinner={isLoading}
        handleSearch={(val: any) => {
          handleSearch(val);
        }}
        columns={playlisttypeDataColumns(handleUpdate)}
      />
      <RouteModal
        isOpen={isModalOpen}
        toggle={handleClose}
        title={
          chechStatusSubmitAndUpdate === "Submit"
            ? "Add Playlist Name"
            : "Edit Playlist Name"
        }
        size="md"
        content={
          <PlaylistTypeModalContent
            type={type}
            handleSubmit={handleSubmit}
            handleClose={handleClose}
            setType={setType}
            chechStatusSubmitAndUpdate={chechStatusSubmitAndUpdate}
          />
        }
      />
    </div>
  );
};

export default PlaylistType;
